import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';

import { connect } from 'react-redux';
import WhatsApp from '../components/html/WhatsApp';
import axios from 'axios';

import * as Constants from './../store/index';

function AICampaigns(props) {
  const { type = "campaing" } = props;
  var shopJson =  Util.getAdminShop();
  

  const [listWa, setListWa] = useState(null);
  const [listBody, setListBody] = useState([]);
  const [listImage, setListImage] = useState([]);
  const [countWa, setCountWa] = useState(0);

  const [name, setName] = useState(shopJson.name);
  const shop = Util.isShopify(Util.getAdminShop()) ? Util.getMetafieldMyshopify_domain() : shopJson.id ;

  const types = {
    "campaing": 1,
    "FLOW": 2,
    "BASIC": 1,
    "AUTOMATIC": 2,
    "NOTIFICATION": 3
  };

  const typeTemplate = types[type];
  
 const getUrlParram = () =>{
    return `?shop=${shop}&url=${shopJson.domain}&name=${name}&country=${shopJson.country}`;
 }
 
  const dataOk = (data) => {
    // 1. Parseamos el primer nivel
    const innerJson = data;//JSON.parse(data);
    // ✅ Ahora ya tienes el objeto interno listo
    //{body, footer, mediaurl, buttontext, name, mediatext="",cards, createdAt}
    let listBody = [];
    listBody.push(innerJson.main_message);
    if(innerJson.variation && innerJson.variation.length > 1){
      for (let i = 0; i < innerJson.variation.length; i++) {
        listBody.push(innerJson.variation[i]);
      }
    }
    setListBody(listBody);
    getPrompt();
    //Util.callServerPHP(dataOkIA, dataOkIA, `ai/image/?shop=${Util.getMetafieldMyshopify_domain()}&prompt=${innerJson.image_prompt}`,{}, "POST");
  }

  const getPrompt = () => {
    Util.callServerPHP(dataPrompt, dataOkIA, `ai/prompt/${getUrlParram()}`,{}, "POST");
  }
  const dataPrompt = (data) => {
    Util.callServerPHP(dataOkIAImage, dataOkIA, `ai/image/${getUrlParram()}`,{}, "POST");
  }

  const dataImage = () => {
    Util.callServerPHP(dataOkIAImage, dataOkIA, `ai/logo/${getUrlParram()}`,{}, "POST");
  }

  const validarImagenes = (urls) => {
    return Promise.all(
      urls.map(url => 
        new Promise(resolve => {
          const img = new Image();
          img.onload = () => resolve({ url, valida: true });
          img.onerror = () => resolve({ url, valida: false });
          img.src = url;
        })
      )
    ).then(results => results.filter(r => r.valida).map(r => r.url));
  }


  const dataOkIAImage = async (data) => {
    let listImagecopy = [];
    if(data && data.length > 1){
      for (let i = 0; i < data.length; i++) {
        listImagecopy.push(data[i]);
      }
    }
    const listaFiltrada = await validarImagenes(listImagecopy);
    setListImage(listaFiltrada);
    setCountWa(countWa + 1);
  }

  const dataOkIA = (data) => {
    let urlImage = data.data;
    let urlImage2 = data.data2;
    let listImage = [];
    listImage.push(urlImage);
    listImage.push(urlImage2);
    setListImage(listImage);
    dataImage();
  }

  const getRandomImage = (images) => {
    if (!images || images.length === 0) return null; // por si la lista está vacía
    const index = Math.floor(Math.random() * images.length);
    return images[index];
  };

  useEffect(() => {
    
    if(countWa > 0){
      let listWaHelp = [];
       for (let i = 0; i < listBody.length; i++) {
         listWaHelp.push({body: listBody[i], footer: "", mediaurl: type === "NOTIFICATION" ? "" : i < 1 ? listImage[i] : getRandomImage(listImage), buttontext: type === "NOTIFICATION" ? "":"Ver oferta", name: "Example"+i, createdAt: "" });
       }
       setListWa(listWaHelp);
    }
  },[countWa]);

  useEffect(() => {
    
    if(countWa > 0 && listWa && listWa.length > 0){
      setTimeout(function(){Util.getContentSid("&update=yes",isOKContent, isOKContent);}.bind(this), 1000);
    }
  },[listWa]);

  const isOKContent = (data) =>{
    if(data.data === ""){
      insertContent(0);
    }else{
       let contentSid = JSON.parse(data.data);
        let call = true;
        Object.keys(contentSid).map((item) => {
            if(typeTemplate === parseInt(contentSid[item].type)){
              call = false;
            }
        });
      if(call){
        insertContent(0);
      }
    }
  }

  const insertContent = (i) => {
    if (i < listWa.length) {
      let wa = listWa[i];
      if(wa.body === undefined || wa.body === null || wa.body === "" ){
        return;
      }
      let url = window.url_server_2+"setcontent/?shop="+Util.getShopDomain();
      wa["accessTokenStore"] = Constants.getAccessTokenStore();
      wa["type"]= typeTemplate;
      axios.post(url, wa, {}).then(response => response.data,error => {
          return error;
        }).then((data) => {
          if (data && data.code === "200"){
            insertContent(i + 1);
          }else{
            alert("Ocurrio un error al crear la plantilla, comuniquese con Revie!");
          }
      });
    }
  }
 
  useEffect(() => {
    if(shopJson.plan.planType !== "PLUS"){
      if(type === "campaing"){
        Util.callServerPHP(dataOk, dataOk, `ai/body/${getUrlParram()}`,{}, "POST");
      }else if(type === "FLOW" || type === "NOTIFICATION"){
        let list = Util.FLOW_CAMPAIGNS;
        if(type === "FLOW" && Util.isTiendaNube(Util.getAdminShop())){
            list = Util.FLOW_CAMPAIGNS_TN;
        }
        if(type === "NOTIFICATION"){
            list = Util.NOTIFICATIONS_CAMPAIGNS;
            if(Util.isTiendaNube(Util.getAdminShop())){
                list = Util.NOTIFICATIONS_CAMPAIGNS_TN;
            }
        }
        list && Object.keys(list).map((key, index) => {
          Util.callServerPHP(dataOk, dataOk, `${list[key].urlAI}${getUrlParram()}`,{}, "POST");
        });
      }
    }
  },[]);

  const goToPedding = () => {
    const { dispatch } = props;
    if(dispatch){
      dispatch({
          type: 'CHANGE_MENU',
          new_option: "/plan"
      });
    }
  }
  
  return (
    <div>
      <div className='content-campaign-ia'>
        <div className='content-table'>
          {type === "campaing" ? (
            <div className='content-create-title'>
              <h1 dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_title")}}  />
              <p><span dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_campaign_1")}} /> <a href="#" class="p5-10 me-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" onClick={() => goToPedding()}>{Util.getMessage("update_plan")}</a></p>
              <p style={{fontSize: "12px"}}><span dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_campaign_2")}} /> </p>
            </div>
          ) : type === "FLOW" ? (
            <div className='content-create-title'>
              <h1 dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_flow_1.1")}}  />
              <p dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_flow_1.1")}}  />
              <p><span dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_flow_1")}} />  <a href="#" class="p5-10 me-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" onClick={() => goToPedding()}>{Util.getMessage("update_plan")}</a></p>
              <p style={{fontSize: "12px"}}><span dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_flow_2")}} />  </p>
            
            </div>
          ) : type === "NOTIFICATION" ? (
            <div className='content-create-title'>
              <h1 dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_notification_1.1")}}  />
              <p dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_notification_1.2")}}  />
              <p><span dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_notification_1")}} />  <a href="#" class="p5-10 me-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" onClick={() => goToPedding()}>{Util.getMessage("update_plan")}</a></p>
              <p style={{fontSize: "12px"}}><span dangerouslySetInnerHTML={{__html: Util.getMessage("ai_title_flow_2")}} /> </p>
            
            </div>
          ) : null}
        </div>
        <div className='content-create-campaign-ia'>
          {listWa && listWa.length > 0 ? listWa.map((wa, index) => {
            return (
              <div className='crate-wa' key={index}>
                <div>
                  Opción {index + 1}
                  <div className='cont-wp'>
                    {<WhatsApp message={wa ? wa : {}} isLoader={wa ? false : true}/>}
                  </div>
                </div>
              </div>
            )
          }) : (
            <>
              <div className='crate-wa'>
                  <div>
                    Opción 1
                    <div className='cont-wp'>
                      {<WhatsApp message={{}} isLoader={true}/>}
                    </div>
                  </div>
                </div>
              <div className='crate-wa'>
                  <div>
                    Opción 2
                    <div className='cont-wp'>
                      {<WhatsApp message={{}} isLoader={true}/>}
                    </div>
                  </div>
                </div>
              <div className='crate-wa'>
                  <div>
                    Opción 3
                    <div className='cont-wp'>
                      {<WhatsApp message={{}} isLoader={true}/>}
                    </div>
                  </div>
                </div>
                <div className='crate-wa'>
                  <div>
                    Opción 4
                    <div className='cont-wp'>
                      {<WhatsApp message={{}} isLoader={true}/>}
                    </div>
                  </div>
                </div>
            </>
          )}
          {/*
          <div className='field-content'>
            <p>Estás viendo una vista previa de cómo la IA puede crear tus campañas.</p>
            <p>Desbloqueá esta función con Plan Plus y llevá tu tienda al siguiente nivel.</p>
            <div className='field'>
              <label>Descripcion</label>
              <textarea disabled={true} type="text" value={description} onChange={(e) => setDescription(e.target.value)} ></textarea>
            </div>
            
            <div className='field'>
              <label>Información</label>
              <input disabled={true} type="text" value={info} onChange={(e) => setInfo(e.target.value)} />
            </div>
            
            <Button value="Generar" type="primary" disabled={true}/>
            <p></p>
            <a href="#" class="p5-10 me-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" onClick={() => goToPedding()}>{Util.getMessage("update_plan")}</a>
          </div>
          */}
        </div>
        <div className='content-reviews promo-campaings'>
          <div className='text' dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_text2")}}  />
          <div className='content-flex'>
            <img src='img/1onboard1.png' />
            <img src='img/2onboard2.png' />
          </div>
          
          <div className='text' dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_text3")}}  />
          <ul>
          <li className='text' dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_text4")}}  />
          <li className='text' dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_text5")}}  />
          <li className='text' dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_text6")}}  />
          </ul>
          <div className='text' dangerouslySetInnerHTML={{__html: Util.getMessage("page_camp_text7")}}  />

          <div className='update-plan-name' style={{width: "110px"}}><a href="#" onClick={() => this.goToPedding()}>{Util.getMessage("update_plan")}</a></div>
          
        </div>
      </div>
    </div>
);
}


const mapStateToProps = (state) => ({
    shop: state.shop,
    filter: state.filter
});

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AICampaigns);